import React, { useEffect, useState } from 'react'
import images from 'constants/images';
import { useParams } from 'react-router-dom';
import { getInvoiceBillRaise, transactionDeleteForSummaryDetails } from '_services/invoiceBillRaiseServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { AddPaymentInvoiceModal, AddTdsInvoiceModal, ClaimInvoiceDetails, LrToLrTdsDeductionModal, PaymentVoucher, SelectLrForClaimInvoice } from 'modals';
import moment from 'moment';
import { utils } from 'helper';
import { FaRegTrashCan } from 'react-icons/fa6';
import toast from 'react-hot-toast'
import { CommonModal } from 'components';
import { constant } from 'constants/constant';
import InvoiceLrToLrPayment from 'modals/InvoiceLrToLrPayment/InvoiceLrToLrPayment';
import InvoiceLrToLrTdsPayment from 'modals/InvoiceLrToLrTdsPayment/InvoiceLrToLrTdsPayment';
import { getVoucherReport } from '_services/accountingServices/accountingServices';
import printHtmlContent from 'helper/utils';

const zeroValue = 0;

const BillSummaryDetails = (props) => {

  let { data, filterData, callInvoiceDetailsApi, claimFieldHide = false } = props

  const [paymentInvoiceData, setPaymentInvoiceData] = useState(false);
  const [selectLrForPayment, setSelectLrForPayment] = useState(false);

  const [tdsInvoiceData, setTdsInvoiceData] = useState(false);

  const [tdsWithLrInvoiceData, setTdsWithLrInvoiceData] = useState(false);
  const [selectLrForTds, setSelectLrForTds] = useState(false);

  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);

  const [isOpenClaim, setIsOpenClaim] = useState(false);
  const [lrDetails, setLrDetails] = useState("");

  const [lrDeleteConfirm, setLrDeleteConfirm] = useState(false);
  const [loadingLrDelete, setLoadingLrDelete] = useState(false);

  const callClaim = (Details) => {
    // if (data?.vehicle_ownership === 2) {
    //   setIsOpenClaim(true);
    // } else {
    //   // setIsOpenOwnClaim(true);
    // }

    setIsOpenClaim(true);
    setLrDetails(Details);
  };

  const closeClaimModal = () => {
    setIsOpenClaim(false);
  };

  let addPaymentInvoiceDetailsProps = {
    isOpen: paymentInvoiceData,
    modalType: paymentInvoiceData,
    closeModal: (e) => setPaymentInvoiceData(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Payment Received",
    submitTitle: (data?.action_type === 1) ? 'Add Payment' : 'Select LR',
    filterData: filterData,
    callInvoiceDetailsApi: () => callInvoiceDetailsApi(),
    callBackSelectLrModal: (data) => setSelectLrForPayment(data),
    billRaiseDetailsData: data,
  };

  let addTdsInvoiceDetailsProps = {
    isOpen: tdsInvoiceData,
    modalType: tdsInvoiceData,
    closeModal: (e) => setTdsInvoiceData(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "TDS Receivable",
    submitTitle: 'Deduct TDS',
    filterData: filterData,
    callInvoiceDetailsApi: () => callInvoiceDetailsApi(),
  };

  let claimProps = {
    isOpen: isOpenClaim,
    closeModal: closeClaimModal,
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Pay Party ",
    submitTitle: "Pay Party",
    filterData: filterData,
    callInvoiceDetailsApi: () => callInvoiceDetailsApi(),
    billRaiseDetailsData: data,
    // tripId: freightId,
    // lrDetails: lrDetails,
    // callBackFreight: callBackFreight,
    // transactionList: transactionList,
    // accountList: accountList,
    // setCanvasOpen: setCanvasOpen,
    // canvasOpen: canvasOpen,
    // userPermission: userPermission?.supplier_freight,
  };

  const submitLrDeleteHandler = async () => {
    setLoadingLrDelete(true);
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        billraise_id: lrDeleteConfirm?.billraise,
        transaction_id: lrDeleteConfirm?.transaction_id,
        voucher_id: lrDeleteConfirm?._id,
      }
      const res = await transactionDeleteForSummaryDetails(object);
      if (res?.responseCode == 200) {
        callInvoiceDetailsApi();
        setPaymentVoucherOpen(false);
        if (res?.responseMessage) {
          toast.success(`${res?.responseMessage}`);
        }
        setLoadingLrDelete(false);
        setLrDeleteConfirm(false)
      } else {
        if (res?.responseMessage) {
          toast.success(`${res?.responseMessage}`);
        }
        setLoadingLrDelete(false);
      }
    } catch (error) {
      setLoadingLrDelete(false);
    }
  }


  const [printLoadingId, setPrintLoadingId] = useState(null);
  const handlePrintDownload = async (voucherId) => {
      try {
        setPrintLoadingId(voucherId);
  
        const res = await getVoucherReport({
          company_id: StorageService?.getCompanyId(),
          voucher_id: voucherId,
        });
  
        printHtmlContent({
          html: res,
          title: `Bilty-${voucherId}`,
          onAfter: () => setPrintLoadingId(false),
        });
  
      } catch (err) {
        console.error('Print error:', err);
        setPrintLoadingId(false);
      }
    };

  let confirmObject = {
    isOpen: lrDeleteConfirm,
    closeModal: (e) => setLrDeleteConfirm(false),
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitLrDeleteHandler,
    isLoadding: loadingLrDelete,
  }

  let lrTolrTdsDeductionModal = {
    isOpen: tdsWithLrInvoiceData,
    closeModal: (e) => setTdsWithLrInvoiceData(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Add TDS Deduction',
    submitTitle: 'Select LR',
    footerPart: true,
    callBackSelectLrModal: (data) => setSelectLrForTds(data),
  }

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    oprnDeleteModal: () => setLrDeleteConfirm(paymentVoucherOpen),
    voucherId: paymentVoucherOpen?._id,
    showLrNumber: true,
    onPrintHandle: handlePrintDownload,
    printLoadingId
  };

  return (
    <>
      {data?.billraise_type != 3 ? <div className="tabsHeadeing_rs">
        {constant.invoiceDetailsSummmaryTabs.map((i) => {
          return (
            <button
              className={`_baseSpan ${i?.value == 1 ? "active" : "_bspDisable"}`}
              // name="account_sub_category"
              // disabled={accountLoading}
              value={i.value}
              // onClick={({ target: { name, value } }) => {
              //   setAccountType(value);
              //   handleOnChange(name, Number(value));
              // }}
            >
              {i.label}
            </button>
          );
        })}
      </div> : <></>}

      <div className='_blsSummary'>
        <div className="bill_symry_details">
          <table className="_trpTable_xd">
            <thead className="table_head_style">
              <tr className="accordiTr">
                <th>Voucher No.</th>
                <th>Type</th>
                <th>Payment Date</th>
                <th>Category</th>
                <th>Description</th>
                <th>From Account</th>
                <th>To Account</th>
                <th>Amount</th>
                <th> Action </th>
              </tr>
            </thead>
            <tbody>
              {
                data?.transactions?.invoice_txn_list?.length > 0 ?
                  (
                    data?.transactions?.invoice_txn_list?.map((items, indexs) => {
                      return (
                        <tr key={indexs + items?.voucher_no}>
                          <td onClick={() => setPaymentVoucherOpen(items)}>
                            <span className="sameSpan _tblText _lrNums __inLineNums">
                              <a className='_avPointer'> {items?.voucher_no ? items?.voucher_no : '-'} </a>
                            </span>
                          </td>
                          {/* | {items?.sub_type_name ? items?.sub_type_name : items?.type_name}  */}
                          <td>
                            <span>
                              {items?.sub_type_name ? items?.sub_type_name : items?.type_name}
                            </span>
                          </td>

                          <td>
                            <span>
                              {items?.date ? moment(items?.date).format('DD MMM YYYY') : '-'}
                            </span>
                            <br />
                          </td>

                          <td>
                            <span>
                              {items?.category_type === 1 ? items?.categories[0]?.category?.name : (items?.category_type === 2 ? items?.category_name : '')}
                              {/* {el?.sub_type_name ? el?.sub_type_name : el?.type_name}  */}
                              {/* {items?.category_name ? items?.category_name : '-'} */}
                            </span>
                            {/* <br />
                            <span className="sameSpan">
                              {items?.categories?.length > 0 ? items?.categories?.map((el, idx) => {
                                return (
                                  <>{el?.category?.name},</>
                                )
                              }) : '-'}
                            </span> */}
                          </td>
                          <td className="sameSpan">
                            {items?.description ? `${utils.spliceString(items?.description, 0, 10)} ${data?.invoice_number ? `| ${data?.invoice_number}` : ''}` : data?.invoice_number}
                          </td>
                          <td>
                            <span>
                              {items?.from_account?.name ? items?.from_account?.name : '-'}
                            </span>
                          </td>

                          <td>
                            <span>
                              {items?.to_account?.name ? items?.to_account?.name : '-'}
                            </span>
                            <br />
                          </td>

                          <td>
                            <span className="sameSpan">
                              &#x20B9; {items?.total_amount ? items?.total_amount.toFixed(2) : 0}
                            </span>
                          </td>

                          <td>
                            <div
                              onClick={(e) => setLrDeleteConfirm(items)}
                              className='_avPointer'
                            >
                              <span className='_samAnchor'>
                                <span className='deleteIcon_avt'>
                                  <FaRegTrashCan color='red' />
                                </span> Delete
                              </span>
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  )
                  :
                  <tr>
                    <td colSpan={8} align='center'>
                      No data found
                    </td>
                  </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={7}>
                  <div className="_muliAddbtns_bx">

                    {/* <button
                      className="addAble_btn addFreight"
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>{" "}
                      <span>Add Freight</span>
                    </button> */}
                    <button
                      className="addAble_btn addFreight"
                      onClick={(e) => setPaymentInvoiceData(true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>{" "}
                      <span>Add Payment</span>
                    </button>

                    <button
                      className="addAble_btn addClaim"
                      onClick={(e) => setIsOpenClaim(true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.CLAIMNEW.default} alt="" />
                      </div>{" "}
                      <span>Add Claims</span>
                    </button>

                    <button
                      className="addAble_btn addFuel"
                      onClick={(e) => {
                        if (data?.action_type === 1) {
                          setTdsInvoiceData(true)
                        } else {
                          setTdsWithLrInvoiceData(true);
                        }
                      }}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images?.TDS_ICON.default} alt="" />
                      </div>{" "}
                      <span>Add TDS</span>
                    </button>
                  </div>
                </td>

                {/* <td></td>
                <td className="_totalAtm">Balance</td>
                <td className="_totalAtm"> 1000 </td>
                <td></td> */}
              </tr>
            </tfoot>
          </table>
        </div>
        <div className='billDetal_viw'>
          <div className='_invoiceSummary'>
            <h2>Invoice Summary</h2>
            <div className='_alInvoiceSumry'>
              <div className='_invsSum_fx'>
                <p className='_blackText'>Payment Receiving Mode</p> <p className='_blackText'> {data?.action_type ? constant.ActionTypeArray?.find((el) => el?.value === data?.action_type)?.label : ''} </p>
              </div>
              <div className='_invsSum_fx'>
                <p className='_blackText'>Bill Raise Type</p> <p className='_blackText'> {constant.typeArray1?.find((el) => el?.id === data?.billraise_type)?.name} </p>
              </div>
              <br />
              {!claimFieldHide && <div className='_invsSum_fx'>
                <p className='_blackText'>Total Freight</p> <p className='_blackText'>
                  {/* &#x20B9; 0.00 */}
                  {data?.invoice_summary?.total_freight ? <> &#x20B9; {(data?.invoice_summary?.total_freight).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                </p>
              </div>}

              <div className='_invsSum_fx'>
                <p className='_blackText'>Claims Receivable (+)</p> <p className='_blackText'>
                  {data?.invoice_summary?.claim_receivable ? <> &#x20B9; {(data?.invoice_summary?.claim_receivable).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                  {/* &#x20B9; 0.00 */}
                </p>
              </div>

              <div className='_invsSum_fx'>
                <p className='_blackText'> GST @ {data?.gst_percentage}% (+) </p> <p className='_blackText'>
                  {data?.invoice_summary?.gst_amount ? <> &#x20B9; {(data?.invoice_summary?.gst_amount).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                  {/* &#x20B9; 0.00 */}
                </p>
              </div>

              <div className='_invsSum_fx'>
                <p className='_boldBlack'>Invoice Amount</p> <p className='_boldBlack'>
                  {/* &#x20B9; 0.00 */}
                  {data?.invoice_summary?.invoice_amount ? <> &#x20B9; {(data?.invoice_summary?.invoice_amount).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                </p>
              </div>

              {!claimFieldHide && <div className='_invsSum_fx'>
                <p className='_blackText'>Freight Received (-)</p>
                <p className='_blackText'>
                  {data?.invoice_summary?.freight_received ? <> &#x20B9; {(data?.invoice_summary?.freight_received).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                  {/* &#x20B9; 0.00 */}
                </p>
              </div>}

              {!claimFieldHide && <div className='_invsSum_fx'>
                <p className='_blackText'>Claims Payable (-)</p> <p className='_blackText'>
                  {data?.invoice_summary?.claim_payable ? <> &#x20B9; {(data?.invoice_summary?.claim_payable).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                  {/* &#x20B9; 0.00 */}
                </p>
              </div>}

              <div className='_invsSum_fx'>
                <p className='_blackText'>TDS Receivable (-)</p> <p className='_blackText'> {data?.invoice_summary?.tds_receivable ? <> &#x20B9; {(data?.invoice_summary?.tds_receivable).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>} </p>
              </div>

              <div className='_invsSum_fx'>
                <p className='remainBal'>Balance</p> <p className='remainBal'>
                  {data?.invoice_summary?.balance ? <> &#x20B9; {(data?.invoice_summary?.balance).toFixed(2)} </> : <> &#x20B9; {zeroValue?.toFixed(2)} </>}
                  {/* &#x20B9; 0.00 */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {paymentInvoiceData && <AddPaymentInvoiceModal {...addPaymentInvoiceDetailsProps} />}

      <div className={`offcanvas offcanvas-end common_offCanvas  xxlOffcanvas ${selectLrForPayment ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: selectLrForPayment ? 'visible' : 'hidden' }}
      >
        {selectLrForPayment &&
          <InvoiceLrToLrPayment
            isOpen={selectLrForPayment}
            onClose={() => { setSelectLrForPayment(false); setPaymentInvoiceData(false) }}
            previousModal={(data) => setPaymentInvoiceData(data)}
            callInvoiceDetailsApi={() => callInvoiceDetailsApi()}
          />
        }
      </div>
      <div className={selectLrForPayment ? 'offBack_drop' : ''}></div>

      {tdsInvoiceData && <AddTdsInvoiceModal {...addTdsInvoiceDetailsProps} />}

      {tdsWithLrInvoiceData &&
        <LrToLrTdsDeductionModal {...lrTolrTdsDeductionModal} />
      }
      <div className={`offcanvas offcanvas-end common_offCanvas  xxlOffcanvas ${selectLrForTds ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: selectLrForTds ? 'visible' : 'hidden' }}
      >
        {selectLrForTds &&
          <InvoiceLrToLrTdsPayment
            isOpen={selectLrForTds}
            onClose={() => { setSelectLrForTds(false); setTdsWithLrInvoiceData(false) }}
            previousModal={(data) => setTdsWithLrInvoiceData(data)}
            callInvoiceDetailsApi={() => callInvoiceDetailsApi()}
            billRaiseDetailsData={data}
          />
        }
      </div>
      <div className={selectLrForTds ? 'offBack_drop' : ''}></div>

      {isOpenClaim && <ClaimInvoiceDetails {...claimProps} />}

      {
        lrDeleteConfirm?._id && (
          <CommonModal {...confirmObject}>
            <p className='p-3'> Are you sure you want to delete transaction ? </p>
          </CommonModal>
        )
      }

      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
    </>
  )
}

export default BillSummaryDetails